import unbindNode from '../../unbindnode/index.js';
import forOwn from '../../_helpers/forown.js';
import forEach from '../../_helpers/foreach.js';
import toArray from '../../_helpers/toarray.js';
import deepBindings from '../../bindnode/_deepbindings.js';
import assign from '../../_helpers/assign.js';
// window and other non-Node targets can't be inside a rendered node; an attribute is where its element is
var isInside = function isInside(boundNode, node) {
  var _boundNode$ownerEleme;
  var target = (_boundNode$ownerEleme = boundNode == null ? void 0 : boundNode.ownerElement) != null ? _boundNode$ownerEleme : boundNode;
  return !!target && typeof target.nodeType === 'number' && (target === node || node.contains(target));
};
// removes every binding of an item to a rendered node or to a node inside it
export default function releaseNode(item, itemDef, node, eventOptions) {
  // deep bindings ("a.b") live at the end of their path; unbindNode finds them by the dotted key
  var toRelease = [];
  forEach(deepBindings.get(item) || [], function (_ref) {
    var key = _ref.key,
      $nodes = _ref.$nodes;
    forEach(toArray($nodes), function (boundNode) {
      if (isInside(boundNode, node)) {
        toRelease.push({
          key: key,
          boundNode: boundNode,
          options: eventOptions
        });
      }
    });
  });
  // own properties, including exact keys with a dot in their name
  var exactKeyOptions = assign({}, eventOptions, {
    exactKey: true
  });
  forOwn(itemDef.props, function (propDef, key) {
    forEach((propDef == null ? void 0 : propDef.bindings) || [], function (_ref2) {
      var boundNode = _ref2.node;
      if (isInside(boundNode, node)) {
        toRelease.push({
          key: key,
          boundNode: boundNode,
          options: exactKeyOptions
        });
      }
    });
  });
  forEach(toRelease, function (_ref3) {
    var key = _ref3.key,
      boundNode = _ref3.boundNode,
      options = _ref3.options;
    return unbindNode(item, key, boundNode, options);
  });
}